export default "__VITE_ASSET__6Yi4H7$n__"